import React, { Component, useEffect, useState } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { reduxForm, Field, getFormValues } from "redux-form";

import ContentCard from "../common/template/contentCard";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";
import Form from "../common/form/form";
import LabelAndInput from "../common/form/labelAndInput";
import LabelAndInputMask from "../common/form/labelAndInputMask";
import Select from "../common/form/select";
import LabelAndCheckbox from "../common/form/labelAndCheckbox";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import {
    setModoTela,
    setModoTelaUC,
    initForm,
    getListaUsuarioAdministradorPorEmpresa,
    initUcForm,
    gerarAcesso,
    getLista,
    definirIdUsuarioImplantacaoTodasUCs,
    removerIdUsuarioImplantacaoTodasUCs,
} from "./clienteActions";

import DateFormat from "../common/dateFormat/DateFormat";
import RadioButton from "../common/form/radioButton";
import { ModalForm } from "../common/dialog/modalForm";
import imagemLampada from "../assets/images/lampada.png";
import imagemGota from "../assets/images/gota.png";
import { IndicadorSituacaoUc } from "./components/IndicadorSituacaoUc";
import { SolCasaUc } from "./components/SolCasaUc";
import { YesNoModal } from "../common/dialog/YesNoModal";

function ClienteForm(props) {
    const [state, setState] = useState({
        tipoCliente: "pf",
        id_usuario_implantacao_todas_uc: null,
        exibirModalDefinirPeriodoImplantacao: false,
        exibirModalRemoverPeriodoImplantacao: false,
        filtro: {
            id_unidade_consumidora: null,
            nr_unidade_consumidora: null,
            somente_inativo: false,
            somente_ativo: false,
            somente_com_data_desligamento: false,
            teste: true,
        },
        exibirModalAdicionarUc: false,
        exibirModalConfirmarRemoverTodasUcsImplantacao: false,
        exibirModalConfirmarDefinirTodasUcsImplantacao: false,
        exibirModalLimparFaturamento: false,
        exibirModalSalvarCliente: false,
        exibirModalSairTela: false,
        exibirModalConfirmarSubmit: false,
        tituloConfirmarSubmit: null,
        retornoSalvar: null,
        exibirModalConfirmarBotaoUc: false,
        modoTelaConfirmarBotaoUc: null,
        itemConfirmarBotaoUc: null,
        submitPendente: null,
    });

    useEffect(() => {
        let exibirCamposFaturamento = false;

        for (let prop in props.formularioValues) {
            if (prop.includes("faturamento") && !!props.formularioValues[prop]) {
                exibirCamposFaturamento = true;
                break;
            }
        }

        setState((prev) => ({
            ...prev,
            tipoCliente: props.formularioValues.cnpj ? "pj" : "pf",
            tipoClienteFaturamento: props.formularioValues.faturamento_cnpj ? "pj" : "pf",
            exibirCamposFaturamento,
            formularioValuesInicial: props.formularioValues,
        }));
    }, []);

    function validarAlteracoesFormulario() {
        if (!state.formularioValuesInicial) return;
        const clienteAntes = JSON.parse(JSON.stringify(state.formularioValuesInicial));
        delete clienteAntes.itens;
        const clienteDepois = JSON.parse(JSON.stringify(props.formularioValues));
        delete clienteDepois.itens;
        return JSON.stringify(clienteAntes) !== JSON.stringify(clienteDepois);
    }

    const idEmpresaCliente = (props.formularioValues || {}).id_empresa;
    const idAnalistaResponsavel = (props.formularioValues || {}).id_usuario_responsavel;
    const listaAnalistasEmpresa = props.listaUsuarioAdministradorEmpresa || {};
    const analistasDaEmpresa = listaAnalistasEmpresa.id_empresa == idEmpresaCliente ? listaAnalistasEmpresa.usuarios || [] : [];

    useEffect(() => {
        if (!idEmpresaCliente) return;
        props.getListaUsuarioAdministradorPorEmpresa(idEmpresaCliente);
    }, [idEmpresaCliente]);

    useEffect(() => {
        if (!idAnalistaResponsavel) return;
        if (!idEmpresaCliente || listaAnalistasEmpresa.id_empresa != idEmpresaCliente) {
            if (!idEmpresaCliente) props.change("id_usuario_responsavel", null);
            return;
        }
        const analistaSelecionado = analistasDaEmpresa.find((usuario) => usuario.id == idAnalistaResponsavel);
        if (!analistaSelecionado) props.change("id_usuario_responsavel", null);
    }, [idEmpresaCliente, idAnalistaResponsavel, listaAnalistasEmpresa]);

    const readOnly = props.excluir || props.reativar || props.visualizar || props.editar_ucs || props.formularioValues.bloquearEdicaoClienteUsuarioImplantacao;
    const readOnlySelectEmpresa = readOnly || props.usuarioLogado.id_empresa;
    const existeUcEmImplantacao = !!(props.formularioValues.itens || []).find((uc) => uc.id_usuario_implantacao);
    const todasUcMesmoImplantador = (props.formularioValues.itens || []).every(
        (uc) => uc.id_usuario_implantacao !== null && uc.id_usuario_implantacao === props.formularioValues.itens[0].id_usuario_implantacao
    );
    // console.log(existeUcEmImplantacao, todasUcMesmoImplantador);
    const ucsSelect = [];
    for (const uc of props.formularioValues.itens || []) {
        ucsSelect.push({ id: uc.numero, valor: `${uc.numero} - ${uc.nome}` });
        for (const ucAgua of uc.unidades_consumidoras_agua || []) {
            ucsSelect.push({ id: ucAgua.numero, valor: `${ucAgua.numero} - ${uc.nome}` });
        }
    }

    function handleResetCamposFaturamento() {
        props.initForm({
            ...props.formularioValues,
            faturamento_email: null,
            faturamento_nome: null,
            faturamento_razao_social: null,
            faturamento_nome_fantasia: null,
            faturamento_cpf: null,
            faturamento_cnpj: null,
            faturamento_inscricao_estadual: null,
            faturamento_inscricao_municipal: null,
            faturamento_telefone: null,
            faturamento_celular: null,
            faturamento_cep: null,
            faturamento_id_cidade: null,
            faturamento_bairro: null,
            faturamento_endereco: null,
            faturamento_numero: null,
            faturamento_complemento: null,
        });
    }
    function submitComCallback(values) {
        const callback = (retorno) =>
            setState((prev) => ({
                ...prev,
                formularioValuesInicial: props.formularioValues, //redefine o formulário inicial para não acusar mais pendencia de salvamento
                exibirModalSalvarCliente: true,
                retornoSalvar: retorno ? retorno.data : null, //só vem retorno ao incluir cliente
            }));

        const submitPendente = () => props.onSubmit(values, callback);
        setState((prev) => ({
            ...prev,
            submitPendente,
            exibirModalConfirmarSubmit: true,
            tituloConfirmarSubmit: props.formularioValues.id ? "Deseja realmente salvar as alterações?" : "Deseja realmente incluir o cliente?",
        }));
    }

    return (
        <>
            <YesNoModal
                title={state.tituloConfirmarSubmit}
                visible={state.exibirModalConfirmarSubmit}
                handleYes={() => {
                    if (state.submitPendente) {
                        state.submitPendente();
                    }
                    setState({ ...state, exibirModalConfirmarSubmit: false, submitPendente: null });
                }}
                handleNo={() => {
                    setState({ ...state, exibirModalConfirmarSubmit: false, submitPendente: null });
                }}
            />
            <YesNoModal
                title="Deseja permanecer nesta tela?"
                visible={state.exibirModalSalvarCliente}
                handleYes={() => {
                    if (!props.formularioValues.id) {
                        props.setModoTela(props.modoTela, state.retornoSalvar);
                        props.initForm(state.retornoSalvar);
                    }
                    setState({ ...state, exibirModalSalvarCliente: false, retornoSalvar: null });
                }}
                handleNo={() => {
                    props.getLista();
                    props.setModoTela("lista");
                    setState({ ...state, exibirModalSalvarCliente: false });
                }}
            />
            <YesNoModal
                title="Há alterações não salvas no formulário do cliente. Deseja ficar na página para salvar?"
                visible={state.exibirModalAdicionarUc}
                handleYes={() => {
                    setState({ ...state, exibirModalAdicionarUc: false });
                }}
                handleNo={() => {
                    //se quer ignorar as alterações, redefine o formulário para os valores iniciais
                    props.initForm({ ...state.formularioValuesInicial });
                    const itemForm = {
                        ativo: true,
                        id_cliente: props.formularioValues.id,
                        id_usuario_implantacao: props.usuarioLogado.usuario_implantacao ? props.usuarioLogado.id : null,
                        numeros_anteriores: [],
                        remotas_alugadas: [],
                        unidades_filhas_mercado_livre: [],
                    };
                    props.setModoTelaUC("cadastroUC", itemForm);
                    props.initUcForm(itemForm);
                    setState({ ...state, exibirModalAdicionarUc: false });
                }}
            />
            <YesNoModal
                title="Há alterações não salvas no formulário do cliente. Deseja ficar na página para salvar?"
                visible={state.exibirModalSairTela}
                handleYes={() => {
                    setState({ ...state, exibirModalSairTela: false });
                }}
                handleNo={() => {
                    props.initForm({ ...state.formularioValuesInicial });
                    props.getLista();
                    props.setModoTela("lista");
                    setState({ ...state, exibirModalSairTela: false });
                }}
            />
            <YesNoModal
                title="Há alterações não salvas no formulário do cliente. Deseja ficar na página para salvar?"
                visible={state.exibirModalConfirmarDefinirTodasUcsImplantacao}
                handleYes={() => {
                    setState({ ...state, exibirModalConfirmarDefinirTodasUcsImplantacao: false });
                }}
                handleNo={() => {
                    //se quer ignorar as alterações, redefine o formulário para os valores iniciais
                    props.initForm({ ...state.formularioValuesInicial });
                    setState({ ...state, exibirModalConfirmarDefinirTodasUcsImplantacao: false, exibirModalDefinirPeriodoImplantacao: true });
                }}
            />
            <YesNoModal
                title="Há alterações não salvas no formulário do cliente. Deseja ficar na página para salvar?"
                visible={state.exibirModalConfirmarRemoverTodasUcsImplantacao}
                handleYes={() => {
                    setState({ ...state, exibirModalConfirmarRemoverTodasUcsImplantacao: false });
                }}
                handleNo={() => {
                    //se quer ignorar as alterações, redefine o formulário para os valores iniciais
                    props.initForm({ ...state.formularioValuesInicial });
                    setState({ ...state, exibirModalConfirmarRemoverTodasUcsImplantacao: false, exibirModalRemoverPeriodoImplantacao: true });
                }}
            />
            <YesNoModal
                title="Há alterações não salvas no formulário do cliente. Deseja ficar na página para salvar?"
                visible={state.exibirModalConfirmarBotaoUc}
                handleYes={() => {
                    setState({ ...state, exibirModalConfirmarBotaoUc: false });
                }}
                handleNo={() => {
                    //se quer ignorar as alterações, redefine o formulário para os valores iniciais
                    props.initForm({ ...state.formularioValuesInicial });
                    props.setModoTelaUC(state.modoTelaConfirmarBotaoUc, state.itemConfirmarBotaoUc);
                    props.initUcForm(state.itemConfirmarBotaoUc);
                    setState({ ...state, exibirModalConfirmarBotaoUc: false, modoTelaConfirmarBotaoUc: null, itemConfirmarBotaoUc: null });
                }}
            />
            <YesNoModal
                title="Tem certeza que deseja limpar todos os campos de faturamento e fechar o formulário?"
                visible={state.exibirModalLimparFaturamento}
                handleYes={() => {
                    handleResetCamposFaturamento();
                    setState({ ...state, exibirModalLimparFaturamento: false, exibirCamposFaturamento: false });
                }}
                handleNo={() => {
                    setState({ ...state, exibirModalLimparFaturamento: false });
                }}
            />
            <Form event={props.handleSubmit(submitComCallback)}>
                <ContentCard>
                    <ContentCardBody>
                        <Row>
                            <Field
                                name="id_empresa"
                                component={Select}
                                label="Empresa *"
                                options={props.listaEmpresa}
                                placeholder="Informe a Empresa"
                                cols="12 12 12 12"
                                readOnly={readOnlySelectEmpresa}
                            />
                        </Row>
                        <Row>
                            <Field
                                name="id_usuario_responsavel"
                                component={Select}
                                label="Analista Responsável"
                                options={analistasDaEmpresa}
                                placeholder="Informe o analista responsável"
                                cols="12 12 12 12"
                                readOnly={readOnly}
                            />
                        </Row>
                        <Row>
                            <Field name="nome" component={LabelAndInput} label="Nome" placeholder="Informe o nome" cols="12 12 12 12" readOnly={readOnly} maxLength={150} />
                            <Field
                                name="endereco"
                                component={LabelAndInput}
                                label="Endereço"
                                placeholder="Informe o endereço"
                                cols="12 12 12 12"
                                readOnly={readOnly}
                                maxLength={100}
                            />
                            <Grid
                                cols="12 12 12 12"
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    height: "min-content",
                                    marginBottom: 20,
                                }}
                            >
                                <RadioButton
                                    nameField="Selecione o tipo de cliente"
                                    options={[
                                        {
                                            id: "pf_cliente",
                                            name: "tipo_cliente",
                                            value: "pf",
                                            conditionChecked: state.tipoCliente === "pf",
                                            event: (e) => {
                                                setState({ ...state, tipoCliente: e.target.value });
                                                props.initForm({
                                                    ...props.formularioValues,
                                                    cnpj: null,
                                                });
                                            },
                                            label: "Pessoa Física",
                                        },
                                        {
                                            id: "pj_cliente",
                                            name: "tipo_cliente",
                                            value: "pj",
                                            conditionChecked: state.tipoCliente === "pj",
                                            event: (e) => {
                                                setState({ ...state, tipoCliente: e.target.value });
                                                props.initForm({
                                                    ...props.formularioValues,
                                                    cpf: null,
                                                });
                                            },
                                            label: "Pessoa Jurídica",
                                        },
                                    ]}
                                    readOnly={readOnly}
                                />
                            </Grid>
                            {state.tipoCliente === "pf" ? (
                                <Field
                                    name="cpf"
                                    component={LabelAndInputMask}
                                    label="CPF"
                                    placeholder="Informe o CPF"
                                    cols="12 12 12 12"
                                    mask="999.999.999-99"
                                    readOnly={readOnly}
                                />
                            ) : (
                                <Field
                                    name="cnpj"
                                    component={LabelAndInputMask}
                                    label="CNPJ"
                                    placeholder="Informe o CNPJ"
                                    cols="12 12 12 12"
                                    mask="99.999.999/9999-99"
                                    readOnly={readOnly}
                                />
                            )}
                        </Row>

                        <Row>
                            <Field
                                name="telefone_residencial"
                                component={LabelAndInputMask}
                                label="Telefone Residencial"
                                placeholder="Informe o número do telefone residencial"
                                cols="12 12 12 6"
                                mask="(99) 9999-9999"
                                readOnly={readOnly}
                            />
                               <Field
                                name="telefone_celular"
                                component={LabelAndInputMask}
                                label="Telefone Celular"
                                placeholder="Informe o número do telefone celular"
                                cols="12 12 12 6"
                                mask="(99) 99999-9999"
                                readOnly={readOnly}
                            />
                        </Row>
                        <Row>
                            <Field
                                name="email_contato"
                                component={LabelAndInput}
                                label="E-mail para acompanhamento de relacionamento"
                                placeholder="Informe o e-mail de contato"
                                cols="12 12 12 12"
                                readOnly={readOnly}
                                maxLength={300}
                            />
                         
                        </Row>
                        <Row style={{ alignItems: "end" }}>
                            <Field
                                name="visualiza_analise_periodo_safra"
                                component={LabelAndCheckbox}
                                label="Habilitar análise período safra"
                                title={{
                                    desmarcado: "O cliente não é enquadrado como atividade Rural, porém está indiretamente relacionado à essa atividade",
                                    marcado: "O cliente não é enquadrado como atividade Rural, porém está indiretamente relacionado à essa atividade",
                                }}
                                cols="12 12 12 4"
                                readOnly={readOnly}
                            />
                            <Field name="cliente_prefeitura" component={LabelAndCheckbox} label="É uma prefeitura" cols="12 12 12 4" readOnly={readOnly} />
                            <Field name="recebe_notificacao_fatura" component={LabelAndCheckbox} label="Receber notificação de fatura" cols="12 12 12 4" readOnly={readOnly} />
                            <Field name="controla_vencimento_fatura" component={LabelAndCheckbox} label="Controlar vencimento das faturas" cols="12 12 12 4" readOnly={readOnly} />
                            <Field name="rotina_download_faturas_ativa" component={LabelAndCheckbox} label="Download automático de faturas" cols="12 12 12 4" readOnly={readOnly} />
                            <Field
                                name="rotina_pagamento_faturas_ativa"
                                component={LabelAndCheckbox}
                                label="Importação automática de pagamentos de faturas"
                                cols="12 12 12 4"
                                readOnly={readOnly}
                            />
                        </Row>

                        {state.exibirCamposFaturamento ? (
                            <Row>
                                <Grid cols="6 6 6 6">
                                    <label>Faturamento</label>
                                </Grid>

                                <Grid
                                    cols="6 6 6 6"
                                    style={{
                                        textAlign: "right",
                                    }}
                                >
                                    {!readOnly && (
                                        <button
                                            type="button"
                                            style={{
                                                backgroundColor: "#ff2040",
                                                color: "#ffffff",
                                                border: "none",
                                                borderRadius: 3,
                                                paddingTop: 5,
                                                width: 30,
                                                height: 30,
                                                marginBottom: -5,
                                            }}
                                            disabled={readOnly}
                                            onClick={() => setState((prev) => ({ ...prev, exibirModalLimparFaturamento: true }))}
                                        >
                                            <i className="fas fa-times"></i>
                                        </button>
                                    )}
                                </Grid>
                            </Row>
                        ) : (
                            <Row>
                                <Grid cols="12 12 6 4" style={{ paddingLeft: 14 }}>
                                    <label>Faturamento</label>
                                    <Button
                                        text="Incluir Dados de Faturamento"
                                        type={"primary"}
                                        style={{ marginLeft: 0, marginBottom: 10 }}
                                        disabled={readOnly}
                                        event={() => {
                                            setState({
                                                ...state,
                                                exibirCamposFaturamento: true,
                                            });
                                        }}
                                    />
                                </Grid>
                            </Row>
                        )}
                        {state.exibirCamposFaturamento ? (
                            <Row
                                style={{
                                    borderRadius: "0.33rem",
                                    boxShadow: "inset 0 0 2px #888",
                                    padding: 15,
                                    margin: "0 1px 15px 1px",
                                }}
                            >
                                <Grid cols="12 12 12 4" style={{ marginBottom: 15 }}>
                                    <RadioButton
                                        readOnly={props.formularioValues.bloquearEdicaoClienteUsuarioImplantacao}
                                        justifyContent="start"
                                        nameField="Selecione o tipo de cliente (faturamento)"
                                        options={[
                                            {
                                                id: "pf_cliente_faturamento",
                                                name: "tipo_cliente_faturamento",
                                                value: "pf",
                                                conditionChecked: state.tipoClienteFaturamento === "pf",
                                                event: (e) => {
                                                    setState({
                                                        ...state,
                                                        tipoClienteFaturamento: e.target.value,
                                                    });
                                                    props.initForm({
                                                        ...props.formularioValues,
                                                        faturamento_razao_social: null,
                                                        faturamento_nome_fantasia: null,
                                                        faturamento_cnpj: null,
                                                        faturamento_inscricao_estadual: null,
                                                        faturamento_inscricao_municipal: null,
                                                    });
                                                },
                                                label: "Pessoa Física",
                                            },
                                            {
                                                id: "pj_cliente_faturamento",
                                                name: "tipo_cliente_faturamento",
                                                value: "pj",
                                                conditionChecked: state.tipoClienteFaturamento === "pj",
                                                event: (e) => {
                                                    setState({
                                                        ...state,
                                                        tipoClienteFaturamento: e.target.value,
                                                    });
                                                    props.initForm({
                                                        ...props.formularioValues,
                                                        faturamento_nome: null,
                                                        faturamento_cpf: null,
                                                    });
                                                },
                                                label: "Pessoa Jurídica",
                                            },
                                        ]}
                                    />
                                </Grid>
                                {state.tipoClienteFaturamento === "pf" ? (
                                    <>
                                        <Field
                                            name="faturamento_nome"
                                            component={LabelAndInput}
                                            label="Nome"
                                            placeholder="Informe o nome (faturamento)"
                                            cols="12 12 12 4"
                                            readOnly={readOnly}
                                            maxLength={150}
                                        />
                                        <Field
                                            name="faturamento_cpf"
                                            component={LabelAndInputMask}
                                            label="CPF"
                                            placeholder="Informe o CPF (faturamento)"
                                            cols="12 12 12 4"
                                            mask="999.999.999-99"
                                            readOnly={readOnly}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <Field
                                            name="faturamento_razao_social"
                                            component={LabelAndInput}
                                            label="Razão Social"
                                            placeholder="Informe a razão social (faturamento)"
                                            cols="12 12 12 4"
                                            readOnly={readOnly}
                                            maxLength={300}
                                        />
                                        <Field
                                            name="faturamento_nome_fantasia"
                                            component={LabelAndInput}
                                            label="Nome Fantasia"
                                            placeholder="Informe a nome fantasia (faturamento)"
                                            cols="12 12 12 4"
                                            readOnly={readOnly}
                                            maxLength={300}
                                        />
                                        <Field
                                            name="faturamento_cnpj"
                                            component={LabelAndInputMask}
                                            label="CNPJ"
                                            placeholder="Informe o CNPJ de faturamento (faturamento)"
                                            cols="12 12 12 4"
                                            mask="99.999.999/9999-99"
                                            readOnly={readOnly}
                                        />
                                        <Field
                                            name="faturamento_inscricao_estadual"
                                            component={LabelAndInput}
                                            label="Inscrição Estadual"
                                            placeholder="Informe a inscrição estadual (faturamento)"
                                            cols="12 12 12 4"
                                            readOnly={readOnly}
                                            maxLength={20}
                                        />
                                        <Field
                                            name="faturamento_inscricao_municipal"
                                            component={LabelAndInput}
                                            label="Inscrição Municipal"
                                            placeholder="Informe a inscrição municipal (faturamento)"
                                            cols="12 12 12 4"
                                            readOnly={readOnly}
                                            maxLength={20}
                                        />
                                    </>
                                )}
                                <Field
                                    name="faturamento_cep"
                                    component={LabelAndInputMask}
                                    label="CEP"
                                    placeholder="Informe o número do CEP (faturamento)"
                                    cols="12 12 12 4"
                                    mask="99999-999"
                                    readOnly={readOnly}
                                />
                                <Field
                                    component={Select}
                                    name="faturamento_id_cidade"
                                    options={props.listaCidade}
                                    label="Cidade"
                                    placeholder="Selecione a cidade (faturamento)"
                                    cols="12 12 12 4"
                                    readOnly={readOnly}
                                />
                                <Field
                                    name="faturamento_bairro"
                                    component={LabelAndInput}
                                    label="Bairro"
                                    placeholder="Informe o bairro (faturamento)"
                                    cols="12 12 12 4"
                                    readOnly={readOnly}
                                    maxLength={100}
                                />
                                <Field
                                    name="faturamento_email"
                                    component={LabelAndInput}
                                    label="E-mail para envio de notas"
                                    placeholder="Informe o e-mail (faturamento)"
                                    cols="12 12 12 4"
                                    readOnly={readOnly}
                                    maxLength={100}
                                />
                                <Field
                                    name="faturamento_telefone"
                                    component={LabelAndInputMask}
                                    label="Telefone"
                                    placeholder="Informe o número do telefone (faturamento)"
                                    cols="12 12 12 4"
                                    mask="(99) 9999-9999"
                                    readOnly={readOnly}
                                />

                                <Field
                                    name="faturamento_celular"
                                    component={LabelAndInputMask}
                                    label="Celular"
                                    placeholder="Informe o número do celular (faturamento)"
                                    cols="12 12 12 4"
                                    mask="(99) 99999-9999"
                                    readOnly={readOnly}
                                />

                                <Field
                                    name="faturamento_numero"
                                    component={LabelAndInput}
                                    label="Número"
                                    placeholder="Informe o número (faturamento)"
                                    cols="12 12 12 4"
                                    readOnly={readOnly}
                                    maxLength={5}
                                />
                                <Field
                                    name="faturamento_complemento"
                                    component={LabelAndInput}
                                    label="Complemento"
                                    placeholder="Informe o complemento (faturamento)"
                                    cols="12 12 12 8"
                                    readOnly={readOnly}
                                    maxLength={100}
                                />
                            </Row>
                        ) : null}
                        {props.formularioValues ? (
                            <>
                                {props.formularioValues.id_usuario ? <label style={{ margin: "10px 0px 20px 8px" }}>Acesso</label> : null}

                                <Grid cols="12 12 12 12">
                                    <Row style={{ alignItems: "end" }}>
                                        {!props.formularioValues.id_usuario ? (
                                            <Grid cols="12 12 4 4">
                                                <label>Acesso</label>
                                                {!props.formularioValues.id && (
                                                    <div style={{ color: "red" }}>Salve o cadastro do cliente para habilitar o botão "Gerar Acesso"</div>
                                                )}
                                                <Button
                                                    text="Gerar Acesso"
                                                    type={"primary"}
                                                    style={{ marginLeft: 0, marginBottom: 16 }}
                                                    // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/cliente.js (gerarAcesso) e no endpoint POST /api/usuario
                                                    disabled={readOnly || !props.formularioValues.id}
                                                    event={() => {
                                                        if (!props.formularioValues.id) return;
                                                        props.gerarAcesso(props.formularioValues);
                                                    }}
                                                />
                                            </Grid>
                                        ) : (
                                            <>
                                                <Field name="login" component={LabelAndInput} label="Login" placeholder="Informe o login" cols="12 12 4 4" readOnly="readOnly" />

                                                <Field
                                                    name="senha_cliente"
                                                    component={LabelAndInput}
                                                    label="Senha"
                                                    placeholder="Informe o senha"
                                                    cols="12 12 4 4"
                                                    readOnly="readOnly"
                                                />
                                            </>
                                        )}
                                        {(props.formularioValues.itens || []).length ? (
                                            <>
                                                <Select
                                                    options={ucsSelect}
                                                    label="Buscar Unidade Consumidora"
                                                    cols="12 12 4 4"
                                                    placeholder="Selecione a UC"
                                                    value={state.filtro.nr_unidade_consumidora}
                                                    onChange={(value) => {
                                                        setState({
                                                            ...state,
                                                            filtro: {
                                                                ...state.filtro,
                                                                nr_unidade_consumidora: value,
                                                            },
                                                        });
                                                    }}
                                                />
                                            </>
                                        ) : null}
                                    </Row>
                                </Grid>
                            </>
                        ) : null}

                        <br />
                        <Row alignCenter={true}>
                            {props.excluir ? (
                                <>
                                    <Grid cols="12 4 3 2" style={{ paddingTop: 5 }}>
                                        <Button
                                            text="Inativar"
                                            type={"dark"}
                                            event={() => {
                                                const submitPendente = () =>
                                                    props.excluir({
                                                        id: props.formularioValues.id,
                                                        desligado: true,
                                                    });
                                                setState({
                                                    ...state,
                                                    exibirModalConfirmarSubmit: true,
                                                    submitPendente,
                                                    tituloConfirmarSubmit: "Deseja realmente inativar o cliente?",
                                                });
                                            }}
                                        />
                                    </Grid>
                                    <Grid cols="12 4 3 2" style={{ paddingTop: 5 }}>
                                        <Button
                                            text="Excluir "
                                            event={() => {
                                                const submitPendente = () =>
                                                    props.excluir({
                                                        id: props.formularioValues.id,
                                                        desligado: false,
                                                    });
                                                setState({
                                                    ...state,
                                                    exibirModalConfirmarSubmit: false,
                                                    submitPendente,
                                                    tituloConfirmarSubmit: "Deseja realmente excluir o cliente do sistema?",
                                                });
                                            }}
                                            type={"danger"}
                                        />
                                    </Grid>
                                </>
                            ) : (
                                <Grid cols="12 4 3 2" style={{ paddingTop: 5 }}>
                                    {props.reativar ? (
                                        <Button
                                            text="Reativar"
                                            type={"success"}
                                            event={() => {
                                                const submitPendente = () =>
                                                    props.reativar({
                                                        id: props.formularioValues.id,
                                                    });
                                                setState({
                                                    ...state,
                                                    exibirModalConfirmarSubmit: true,
                                                    submitPendente,
                                                    tituloConfirmarSubmit: "Deseja realmente reativar o cliente?",
                                                });
                                            }}
                                        />
                                    ) : (
                                        <Button
                                            text="Salvar"
                                            style={validarAlteracoesFormulario() ? { boxShadow: "0 0 8px #00ff7b" } : {}}
                                            submit
                                            type={"success"}
                                            disabled={readOnly}
                                        />
                                    )}
                                </Grid>
                            )}

                            <Grid cols="12 4 3 2" style={{ paddingTop: 5 }}>
                                <Button
                                    text="Voltar"
                                    type={"warning"}
                                    icon={"fa fa-chevron-left"}
                                    event={() => {
                                        if (validarAlteracoesFormulario()) {
                                            setState({ ...state, exibirModalSairTela: true });
                                        } else {
                                            props.getLista();
                                            props.setModoTela("lista");
                                        }
                                    }}
                                />
                            </Grid>
                        </Row>
                    </ContentCardBody>
                </ContentCard>
                <ContentCard>
                    <ContentCardBody>
                        {state.exibirModalDefinirPeriodoImplantacao ? (
                            <ModalForm
                                titulo="Definir Período de Implantação para Todas as UCs"
                                item={{ ...state }}
                                handleSubmit={(form) => {
                                    const submitPendente = () =>
                                        props.definirIdUsuarioImplantacaoTodasUCs({
                                            id_cliente: props.formularioValues.id,
                                            id_usuario_implantacao_todas_uc: form.id_usuario_implantacao_todas_uc,
                                            callback: () =>
                                                setState({
                                                    ...state,
                                                    id_usuario_implantacao_todas_uc: null,
                                                    exibirModalDefinirPeriodoImplantacao: false,
                                                }),
                                        });
                                    setState((prev) => ({
                                        ...prev,
                                        submitPendente,
                                        exibirModalConfirmarSubmit: true,
                                        exibirModalDefinirPeriodoImplantacao: false,
                                        tituloConfirmarSubmit: "Deseja realmente incluir o usuário implantação à todas as unidades consumidoras?",
                                    }));
                                }}
                                handleClose={() =>
                                    setState({
                                        ...state,
                                        id_usuario_implantacao_todas_uc: null,
                                        exibirModalDefinirPeriodoImplantacao: false,
                                    })
                                }
                            >
                                <Select
                                    style={{ marginTop: 40 }}
                                    name="id_usuario_implantacao_todas_uc"
                                    options={props.listaUsuarioImplantacao}
                                    label="Nome do Usuário de Implantação"
                                    cols="12 12 12 12"
                                    placeholder="Selecione o usuário de implantação"
                                    readOnly={readOnly}
                                    isClearable={false}
                                />
                            </ModalForm>
                        ) : null}

                        {state.exibirModalRemoverPeriodoImplantacao ? (
                            <ModalForm
                                titulo="Remover Período de Implantação para Todas as UCs"
                                item={{ ...state }}
                                textoBotaoSubmit="Confirmar"
                                handleSubmit={() => {
                                    props.removerIdUsuarioImplantacaoTodasUCs({
                                        id_cliente: props.formularioValues.id,
                                        callback: () => setState({ ...state, exibirModalRemoverPeriodoImplantacao: false }),
                                    });
                                }}
                                handleClose={() => setState({ ...state, exibirModalRemoverPeriodoImplantacao: false })}
                            >
                                <p style={{ marginBlock: 40, textAlign: "center" }} className="text-danger">
                                    Deseja realmente remover o usuário de implantação de todas as unidades consumidoras?
                                </p>
                            </ModalForm>
                        ) : null}

                        <Row style={{ padding: "10px 10px 30px 10px" }}>
                            <Grid cols="12 12 6 4">
                                <Button
                                    title={
                                        props.formularioValues.id
                                            ? "Incluir uma nova unidade consumidora"
                                            : "Cadastre o cliente primeiro para poder adicionar unidades consumidoras"
                                    }
                                    text="Adicionar Nova Unidade Consumidora"
                                    type={"primary"}
                                    icon={"fa fa-plus"}
                                    disabled={
                                        props.visualizar || //bloqueia adicionar pelo modo visualização
                                        props.excluir || //bloqueia adição no modo excluir
                                        props.reativar || //modo reativar n pode editar
                                        !props.formularioValues.id || //bloqueia adição enquanto o cliente ainda não está cadastrado
                                        // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/cliente.js (incluirUnidadeConsumidora) e no endpoint POST /api/unidadeConsumidora
                                        (props.editar_ucs && !props.usuarioLogado.usuario_implantacao && !props.usuarioLogado.acesso_unidade_consumidora_adicionar)
                                    }
                                    style={{ marginLeft: 0 }}
                                    event={() => {
                                        if (validarAlteracoesFormulario()) {
                                            setState({ ...state, exibirModalAdicionarUc: true });
                                        } else {
                                            const itemForm = {
                                                ativo: true,
                                                id_cliente: props.formularioValues.id,
                                                id_usuario_implantacao: props.usuarioLogado.usuario_implantacao ? props.usuarioLogado.id : null,
                                                numeros_anteriores: [],
                                                remotas_alugadas: [],
                                                unidades_filhas_mercado_livre: [],
                                            };
                                            props.setModoTelaUC("cadastroUC", itemForm);
                                            props.initUcForm(itemForm);
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid cols="12 12 6 4">
                                <Button
                                    title={"Incluir Período de Implantação (Todas UCs)"}
                                    text="Incluir Período de Implantação (Todas UCs)"
                                    type={"info"}
                                    icon={"fa fa-cog"}
                                    disabled={
                                        props.excluir || //bloqueia adição no modo excluir
                                        props.reativar || //modo reativar n pode editar
                                        !props.formularioValues.id || //bloqueia adição enquanto o cliente ainda não está cadastrado
                                        !(props.formularioValues.itens || []).length || //se não tiver ucs na lista
                                        todasUcMesmoImplantador ||
                                        (props.usuarioLogado.usuario_implantacao && !todasUcMesmoImplantador) ||
                                        // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/cliente.js (definirImplantacao) e no endpoint PUT /api/unidadeConsumidora/definirIdUsuarioImplantacaoTodasUCs
                                        (props.visualizar && !props.usuarioLogado.usuario_implantacao && !props.usuarioLogado.acesso_unidade_consumidora_editar)
                                    }
                                    style={{ marginLeft: 0 }}
                                    event={() => {
                                        if (validarAlteracoesFormulario()) {
                                            setState({ ...state, exibirModalConfirmarDefinirTodasUcsImplantacao: true });
                                        } else {
                                            setState({ ...state, exibirModalDefinirPeriodoImplantacao: true });
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid cols="12 12 6 4">
                                <Button
                                    title={"Remover Período de Implantação (Todas UCs)"}
                                    text="Remover Período de Implantação (Todas UCs)"
                                    type={"danger"}
                                    icon={"fa fa-cog"}
                                    disabled={
                                        props.excluir || //bloqueia adição no modo excluir
                                        props.reativar || //modo reativar n pode editar
                                        !props.formularioValues.id || //bloqueia adição enquanto o cliente ainda não está cadastrado
                                        !(props.formularioValues.itens || []).length || //se não tiver ucs na lista
                                        !existeUcEmImplantacao || //se ja ta tudo sem implantação desabilita
                                        !todasUcMesmoImplantador || //se ja tiver tudo com implantação definido, desabilita
                                        // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/cliente.js (removerImplantacao) e no endpoint PUT /api/unidadeConsumidora/removerIdUsuarioImplantacaoTodasUCs
                                        (props.visualizar && !props.usuarioLogado.usuario_implantacao && !props.usuarioLogado.acesso_unidade_consumidora_editar)
                                    }
                                    style={{ marginLeft: 0 }}
                                    event={() => {
                                        if (validarAlteracoesFormulario()) {
                                            setState({ ...state, exibirModalConfirmarRemoverTodasUcsImplantacao: true });
                                        } else {
                                            setState({ ...state, exibirModalRemoverPeriodoImplantacao: true });
                                        }
                                    }}
                                />
                            </Grid>
                        </Row>
                        <Row style={{ alignItems: "center" }}>
                            <div
                                style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                onClick={() =>
                                    setState({
                                        ...state,
                                        filtro: {
                                            ...state.filtro,
                                            somente_ativo: !state.filtro.somente_ativo,
                                            somente_inativo: false,
                                            somente_com_data_desligamento: false,
                                        },
                                    })
                                }
                            >
                                <div
                                    style={{
                                        width: 24,
                                        height: 20,
                                        border: "2px solid #fff",
                                        backgroundColor: "#dcdcdc",
                                        boxShadow: "0px 0px 5px 2px #b1b1b1",
                                        margin: "15px 20px 15px 30px",
                                        borderRadius: 4,
                                        textAlign: "center",
                                        lineHeight: "18px",
                                    }}
                                >
                                    {state.filtro.somente_ativo ? <i class="fas fa-check"></i> : null}
                                </div>
                                <b>UCs ativas sem data de desligamento ({(props.formularioValues.itens || []).filter((item) => item.ativo && !item.data_desligamento).length})</b>
                            </div>
                            <div
                                style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                onClick={() =>
                                    setState({
                                        ...state,
                                        filtro: {
                                            ...state.filtro,
                                            somente_inativo: !state.filtro.somente_inativo,
                                            somente_com_data_desligamento: false,
                                            somente_ativo: false,
                                        },
                                    })
                                }
                            >
                                <div
                                    style={{
                                        width: 24,
                                        height: 20,
                                        border: "2px solid #fff",
                                        backgroundColor: "#ff6569",
                                        boxShadow: "0px 0px 5px 2px #b1b1b1",
                                        margin: "15px 20px 15px 30px",
                                        borderRadius: 4,
                                        textAlign: "center",
                                        lineHeight: "18px",
                                    }}
                                >
                                    {state.filtro.somente_inativo ? <i class="fas fa-check"></i> : null}
                                </div>
                                <b>UCs inativas ({(props.formularioValues.itens || []).filter((item) => !item.ativo).length})</b>
                            </div>
                            <div
                                style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                onClick={() =>
                                    setState({
                                        ...state,
                                        filtro: {
                                            ...state.filtro,
                                            somente_com_data_desligamento: !state.filtro.somente_com_data_desligamento,
                                            somente_inativo: false,
                                            somente_ativo: false,
                                        },
                                    })
                                }
                            >
                                <div
                                    style={{
                                        width: 24,
                                        height: 20,
                                        border: "2px solid #fff",
                                        backgroundColor: "#ffe367",
                                        boxShadow: "0px 0px 5px 2px #b1b1b1",
                                        margin: "15px 20px 15px 30px",
                                        borderRadius: 4,
                                        textAlign: "center",
                                        lineHeight: "18px",
                                    }}
                                >
                                    {state.filtro.somente_com_data_desligamento ? <i class="fas fa-check"></i> : null}
                                </div>
                                <b>UCs ativas com data de desligamento ({(props.formularioValues.itens || []).filter((item) => item.ativo && item.data_desligamento).length})</b>
                            </div>
                        </Row>
                        <Table maxHeight="40vh" responsive>
                            <THead>
                                <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                                    <Th alignCenter={true} sticky>
                                        Situação
                                    </Th>
                                    <Th alignCenter={true} minWidth={110} sticky>
                                        Concessionária
                                    </Th>
                                    <Th alignCenter={true} sticky>
                                        Geração
                                    </Th>
                                    <Th alignCenter={true} minWidth={110} sticky>
                                        Código da UC
                                    </Th>
                                    <Th alignCenter={true} sticky>
                                        Nome
                                    </Th>
                                    <Th alignCenter={true} sticky>
                                        UF
                                    </Th>
                                    <Th alignCenter={true} sticky>
                                        Tipo Atividade
                                    </Th>
                                    <Th alignCenter={true} minWidth={80} sticky>
                                        (% ICMS)
                                    </Th>
                                    <Th alignCenter={true} sticky>
                                        Grupo Faturamento
                                    </Th>
                                    <Th sticky>Tipo Mercado</Th>
                                </NewTr>
                            </THead>
                            <TBody>
                                {(props.formularioValues.itens || [])
                                    .filter((item) => {
                                        const filtroUC =
                                            !state.filtro.nr_unidade_consumidora ||
                                            item.numero == state.filtro.nr_unidade_consumidora ||
                                            (item.unidades_consumidoras_agua || []).find((uc) => uc.numero == state.filtro.nr_unidade_consumidora);
                                        const filtroAtivas = !state.filtro.somente_ativo || (item.ativo && !item.data_desligamento);
                                        const filtroInativas = !state.filtro.somente_inativo || !item.ativo;
                                        const filtroDataDesligamento = !state.filtro.somente_com_data_desligamento || (item.ativo && item.data_desligamento);
                                        return filtroUC && filtroInativas && filtroAtivas && filtroDataDesligamento && !item.bloquearEdicaoUcUsuarioImplantacao;
                                    })
                                    .map((item) => {
                                        const numeroAjustado =
                                            item.numero && String(item.numero).indexOf(" (ANT:") >= 0
                                                ? String(item.numero).substring(0, String(item.numero).indexOf(" (ANT:"))
                                                : item.numero;
                                        const mensagemEnergiaAjustada = `DOWNLOAD E IMPORTAÇÃO - ${
                                            item.mensagem_ultima_importacao_fatura || "Sem informação"
                                        }\nDATA DE PAGAMENTO - ${item.mensagem_ultima_importacao_data_pagamento || "Sem informação"}\nSALDO - ${
                                            item.mensagem_ultima_importacao_saldo || "Sem informação"
                                        }`;

                                        const mensagemAguaAjustada = `DOWNLOAD E IMPORTAÇÃO - ${
                                            item.mensagem_ultima_importacao_fatura_agua || "Sem informação"
                                        }\nDATA DE PAGAMENTO - ${item.mensagem_ultima_importacao_data_pagamento_agua || "Sem informação"}`;

                                        const competenciaMercadoLivreFormatada = `${String(item.competencia_inicio_mercado_livre).substring(4, 6)}/${String(
                                            item.competencia_inicio_mercado_livre
                                        ).substring(0, 4)}`;

                                        const competenciaGeracaoFormatada = `${String(item.competencia_inicio_geracao).substring(4, 6)}/${String(
                                            item.competencia_inicio_geracao
                                        ).substring(0, 4)}`;

                                        const itemForm = {
                                            ...item,
                                            numero: numeroAjustado,
                                            mensagens_importacao: mensagemEnergiaAjustada,
                                            mensagens_importacao_agua: mensagemAguaAjustada,
                                            data_desligamento: DateFormat.formatarDataSqlParaTela(item.data_desligamento),
                                            competencia_inicio_mercado_livre: item.competencia_inicio_mercado_livre ? competenciaMercadoLivreFormatada : null,
                                            competencia_inicio_geracao: item.competencia_inicio_geracao ? competenciaGeracaoFormatada : null,
                                            id_unidade_geradora: item.geradora_externa ? 0 : item.id_unidade_geradora,
                                            id_tipo_transformador: item.id_tipo_transformador || (item.id_grupo_faturamento == 2 ? 2 : 1),
                                        };
                                        let backgroundColorTr = "#ffffff";
                                        let backgroundColorTd = "#f5f5f5";

                                        if (!item.ativo) {
                                            backgroundColorTr = "#ff6569";
                                            backgroundColorTd = "#fbcaca";
                                        } else if (item.ativo && item.data_desligamento) {
                                            backgroundColorTr = "#ffe367";
                                            backgroundColorTd = "#ffe5bd";
                                        }

                                        const concessionaria = (props.listaConcessionaria.find((c) => c.id == item.id_concessionaria) || {}).valor;
                                        const aliquotaIcms = (props.listaTributacao.find((t) => t.id == item.id_tributacao) || {}).aliquota_icms;
                                        const uf = (props.listaEstado.find((c) => c.id == item.id_estado) || {}).valor;
                                        const atividade = (props.listaAtividade.find((a) => a.id == item.id_atividade) || {}).valor;
                                        const grupoFaturamento = (props.listaGrupoFaturamento.find((g) => g.id == item.id_grupo_faturamento) || {}).valor;
                                        const tipoMercado = (props.listaTipoMercado.find((m) => m.id == item.id_tipo_mercado) || {}).valor;

                                        const {
                                            usuario_implantacao,
                                            acesso_credenciais_concessionaria_editar,
                                            acesso_codigo_uc_editar,
                                            acesso_unidade_consumidora_visualizar,
                                            acesso_unidade_consumidora_editar,
                                            acesso_unidade_consumidora_excluir,
                                        } = props.usuarioLogado;

                                        //usuario implantacao tem acesso total a uc, se nao for implantacao, valida as permissoes da uc

                                        const podeEditarApenasAlgunsCamposUc =
                                            !props.visualizar &&
                                            !props.excluir &&
                                            !item.bloquearEdicaoUcUsuarioImplantacao &&
                                            // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/cliente.js (alterarPropriedadeUnidadeConsumidora) e no endpoint PUT /api/unidadeConsumidora/alterarPropriedadeUC
                                            (acesso_credenciais_concessionaria_editar || acesso_codigo_uc_editar);

                                        const condicaoVisualizarUc = acesso_unidade_consumidora_visualizar || usuario_implantacao;
                                        // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/cliente.js (editarUnidadeConsumidora, reativarUnidadeConsumidora, incluirUnidadeConsumidoraAgua, editarUnidadeConsumidoraAgua, excluirUnidadeConsumidoraAgua) e nos endpoints PUT /api/unidadeConsumidora, PUT /api/unidadeConsumidora/reativar e POST, PUT e DELETE /api/unidadeConsumidoraAgua
                                        const condicaoEditarUc =
                                            !props.visualizar &&
                                            !props.excluir &&
                                            !item.bloquearEdicaoUcUsuarioImplantacao &&
                                            (acesso_unidade_consumidora_editar || usuario_implantacao);

                                        // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/cliente.js (excluirUnidadeConsumidora) e no endpoint DELETE /api/unidadeConsumidora
                                        const condicaoExcluirUc =
                                            !props.visualizar &&
                                            !props.excluir &&
                                            !item.bloquearEdicaoUcUsuarioImplantacao &&
                                            (acesso_unidade_consumidora_excluir || usuario_implantacao);

                                        const eventoCliqueBotaoUc = (modoTela) => {
                                            if (validarAlteracoesFormulario()) {
                                                setState({ ...state, exibirModalConfirmarBotaoUc: true, modoTelaConfirmarBotaoUc: modoTela, itemConfirmarBotaoUc: itemForm });
                                            } else {
                                                props.setModoTelaUC(modoTela, itemForm);
                                                props.initUcForm(itemForm);
                                            }
                                        };

                                        const botoes = [
                                            {
                                                type: "primary",
                                                icon: "fas fa-eye",
                                                disabled: !condicaoVisualizarUc,
                                                event: () => eventoCliqueBotaoUc("visualizacaoUC"),
                                            },
                                        ];

                                        if (item.ativo) {
                                            botoes.push(
                                                {
                                                    type: "warning",
                                                    icon: "fas fa-pencil-alt",
                                                    disabled: !condicaoEditarUc && !podeEditarApenasAlgunsCamposUc,
                                                    event: () => {
                                                        const modoTelaEditar = condicaoEditarUc ? "cadastroUC" : "editarCampoUC";
                                                        eventoCliqueBotaoUc(modoTelaEditar);
                                                    },
                                                },
                                                {
                                                    type: "danger",
                                                    icon: "fas fa-trash-alt",
                                                    disabled: !condicaoExcluirUc,
                                                    event: () => eventoCliqueBotaoUc("exclusaoUC"),
                                                }
                                            );
                                        } else {
                                            botoes.push({
                                                type: "success",
                                                icon: "fas fa-power-off",
                                                disabled: !condicaoEditarUc,
                                                event: () => eventoCliqueBotaoUc("reativarUC"),
                                            });
                                        }

                                        return (
                                            <NewTr key={item.id} backgroundColorTd={backgroundColorTd} backgroundColorTr={backgroundColorTr} botoes={botoes}>
                                                <Td alignCenter={true}>
                                                    <IndicadorSituacaoUc item={item} />
                                                </Td>
                                                <Td alignCenter={true}>
                                                    {item.unidades_consumidoras_agua.length ? (
                                                        <>
                                                            <div style={{ border: "1px solid #aaa", padding: 4 }}>
                                                                {concessionaria} <img style={{ marginLeft: 5, marginBottom: 4 }} src={imagemLampada} height={17} alt="" />
                                                            </div>
                                                            {item.unidades_consumidoras_agua.map((ucAgua) => {
                                                                const concessionariaAgua = (props.listaConcessionariaAgua.find((c) => c.id == ucAgua.id_concessionaria_agua) || {})
                                                                    .valor;

                                                                return concessionariaAgua ? (
                                                                    <div
                                                                        style={{
                                                                            borderLeft: "1px solid #aaa",
                                                                            borderBottom: "1px solid #aaa",
                                                                            borderRight: "1px solid #aaa",
                                                                            padding: 4,
                                                                        }}
                                                                    >
                                                                        {concessionariaAgua} <img style={{ marginLeft: 5, marginBottom: 4 }} src={imagemGota} height={14} alt="" />
                                                                    </div>
                                                                ) : null;
                                                            })}
                                                        </>
                                                    ) : (
                                                        <div> {concessionaria} </div>
                                                    )}
                                                </Td>
                                                <Td fontSize="0.85rem" minWidth={80} alignCenter>
                                                    <SolCasaUc uc={item} />
                                                </Td>
                                                <Td alignCenter={true}>
                                                    {item.unidades_consumidoras_agua.length ? (
                                                        <>
                                                            <div style={{ border: "1px solid #aaa", padding: 4 }}>{item.numero}</div>
                                                            {item.unidades_consumidoras_agua.map((ucAgua) => (
                                                                <div
                                                                    style={{
                                                                        borderLeft: "1px solid #aaa",
                                                                        borderBottom: "1px solid #aaa",
                                                                        borderRight: "1px solid #aaa",
                                                                        padding: 4,
                                                                    }}
                                                                >
                                                                    {ucAgua.numero || " - "}
                                                                </div>
                                                            ))}
                                                        </>
                                                    ) : (
                                                        item.numero
                                                    )}
                                                </Td>
                                                <Td minWidth={250} paddingLeft={5}>
                                                    {item.nome}
                                                </Td>
                                                <Td alignCenter={true} minWidth={130}>
                                                    {uf}
                                                </Td>
                                                <Td alignCenter={true} minWidth={130}>
                                                    {atividade}
                                                </Td>
                                                <Td alignCenter={true}>{aliquotaIcms ? aliquotaIcms.replace(".", ",") + "%" : ""}</Td>
                                                <Td alignCenter={true}>{grupoFaturamento}</Td>
                                                <Td minWidth={110}>{tipoMercado}</Td>
                                            </NewTr>
                                        );
                                    })}
                            </TBody>
                        </Table>
                    </ContentCardBody>
                </ContentCard>
            </Form>
        </>
    );
}

const ClienteFormRedux = reduxForm({ form: "clienteForm", destroyOnUnmount: false })(ClienteForm);
const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
    modoTela: state.cliente.modoTela,
    formularioValues: getFormValues("clienteForm")(state),
    listaCidade: state.cliente.listaCidade,
    listaConcessionaria: state.cliente.listaConcessionaria,
    listaConcessionariaAgua: state.cliente.listaConcessionariaAgua,
    listaGrupoFaturamento: state.cliente.listaGrupoFaturamento,
    listaTipoMercado: state.cliente.listaTipoMercado,
    listaTributacao: state.tributacao.lista,
    listaEstado: state.tributacao.listaEstado,
    listaAtividade: state.tributacao.listaAtividade,
    listaEmpresa: state.empresa.listaSelect,
    listaUsuarioAdministradorEmpresa: state.cliente.listaUsuarioAdministradorEmpresa,
    listaUsuarioImplantacao: state.usuario.lista.filter((item) => item.usuario_implantacao).map((item) => ({ id: item.id, valor: item.nome })),
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            setModoTelaUC,
            initForm,
            getListaUsuarioAdministradorPorEmpresa,
            initUcForm,
            gerarAcesso,
            getLista,
            definirIdUsuarioImplantacaoTodasUCs,
            removerIdUsuarioImplantacaoTodasUCs,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(ClienteFormRedux);
